import { service } from "../utils/request";

//员工列表
export function employeeList(data) {
  return service({
    url: "offlinestore/agent.employee/index",
    method: "post",
    data: data
  });
}

//删除员工
export function employeeDel(data) {
  return service({
    url: "offlinestore/agent.employee/del",
    method: "post",
    data: data
  });
}

//添加新账号员工
export function employeeAdd(data) {
  return service({
    url: "offlinestore/agent.employee/newEmp",
    method: "post",
    data: data
  });
}

//已有账号绑定员工
export function employeeBind(data) {
  return service({
    url: "offlinestore/agent.employee/relateEmp",
    method: "post",
    data: data
  });
}

//获取门店下拉菜单
export function storeSelect(data) {
  return service({
    url: "offlinestore/agent.store/roomSelect",
    method: "post",
    data: data
  });
}

//验证手机号是否已注册
export function judgeUser(data) {
  return service({
    url: "offlinestore/agent.employee/judgeUser",
    method: "post",
    data: data
  });
}

//员工详情
export function employeeDetail(data) {
  return service({
    url: "offlinestore/agent.employee/detail",
    method: "post",
    data: data
  });
}

//员工修改
export function employeeEdit(data) {
  return service({
    url: "offlinestore/agent.employee/editEmp",
    method: "post",
    data: data
  });
}

// 新生成二维码
export function getQrcode(data) {
  return service({
    url: "offlinestore/agent.wechat_qrcode/getQrcode",
    method: "post",
    data: data
  });
}

// 获取普通二维码
export function getPtQrcode(data) {
  return service({
    url: "offlinestore/agent.qrcode/create",
    method: "post",
    data: data
  });
}

// 获取关注二维码
export function getGzQrcode(data) {
  return service({
    url: "offlinestore/agent.wechat_qrcode/getQrcode",
    method: "post",
    data: data
  });
}

// 下载普通二维码
export function downloadPtQrcode(data) {
  return service({
    url: "offlinestore/agent.qrcode/downLoad",
    method: "get",
    params: data
  });
}

// 下载关注二维码
export function downloadGzQrcode(data) {
  return service({
    url: "offlinestore/agent.wechat_qrcode/downLoad",
    method: "get",
    data: data
  });
}

// 删除二维码
export function delQrcode(data) {
  return service({
    url: "offlinestore/agent.wechat_qrcode/del",
    method: "post",
    data: data
  });
}

// 查看二维码收款记录
export function qrcodeOrder(data) {
  return service({
    url: "offlinestore/agent.wechat_qrcode/order",
    method: "post",
    data: data
  });
}

// 角色列表
export function roleList(data) {
  return service({
    url: "offlinestore/agent.Offlinerule/index",
    method: "post",
    data: data
  });
}

// 角色添加
export function roleAdd(data) {
  return service({
    url: "offlinestore/agent.Offlinerule/add",
    method: "post",
    data: data
  });
}

// 角色修改
export function roleEdit(data) {
  return service({
    url: "offlinestore/agent.Offlinerule/edit",
    method: "post",
    data: data
  });
}

// 角色删除
export function roleDel(data) {
  return service({
    url: "offlinestore/agent.Offlinerule/del",
    method: "post",
    data: data
  });
}

// 角色详情
export function roleDetail(data) {
  return service({
    url: "offlinestore/agent.Offlinerule/detail",
    method: "post",
    data: data
  });
}

// 角色权限集列表
export function ruleList(data) {
  return service({
    url: "offlinestore/agent.offlinerule/ruleList",
    method: "post",
    data: data
  });
}

// 员工提成规则列表
export function commissionList(data) {
  return service({
    url: "offlinestore/agent.emp_commission_rule/index",
    method: "get",
    params: data
  });
}
// 员工提成规则添加
export function commissionAdd(data) {
  return service({
    url: "offlinestore/agent.emp_commission_rule/add",
    method: "post",
    data: data
  });
}
// 员工提成规则详情
export function commissionDetail(data) {
  return service({
    url: "offlinestore/agent.emp_commission_rule/detail",
    method: "get",
    params: data
  });
}
// 员工提成规则删除
export function commissionDel(data) {
  return service({
    url: "offlinestore/agent.emp_commission_rule/del",
    method: "post",
    data: data
  });
}
// 员工提成记录
export function empCommission(data) {
  return service({
    url: "offlinestore/agent.emp_commission/index",
    method: "get",
    params: data
  });
}
// 员工提成记录
export function commissionEdit(data) {
  return service({
    url: "offlinestore/agent.emp_commission_rule/edit",
    method: "post",
    data: data
  });
}
